<template>
    <div>
        <compWrapper
            :title="
                $t('fbb.expresspackage.baseinfo', { defaultValue: '基本信息' })
            "
            theme="primary"
        >
            <compFormQuery
                :formdata="getBase"
                :value="formData"
                :labelWidth="235"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.parcel_information', { defaultValue: '包裹信息' })
            "
            theme="error"
        >
            <compFormQuery
                :formdata="getPackage"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.fedex.basecost_detail', {
                    defaultValue: '基础费用明细',
                })
            "
            theme="info"
        >
            <compFormQuery
                :formdata="getBaseCost"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.fedex.extracost_detail', { defaultValue: '附加费明细' })
            "
            theme="info"
        >
            <compTablelist
                class="margin-layout"
                :columns="columnsList"
                :data="extraList"
            ></compTablelist>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <compLog
                class="margin-15"
                :data="opLogList"
                :columns="getLogcolumns"
            ></compLog>
        </compWrapper>
        <div class="text-right">
            <vButton class="width-15per margin-left-10" @click="cancel">{{
                this.$t("global.common.return", { defaultValue: "返回" })
            }}</vButton>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { HttpBillImportOne, HttpImportItem, HttpGetLog } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from "../fedexcost/mixin";

export default {
    mixins: [mixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compTablelist: () => import("@components/templates/tablelist"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            query: false,
            opLogList: [],
            detailList: [],
            columns: [],
            Logcolumns: [],
            extraList: [],
            formData: {
                // remark:'',
            },
        };
    },
    created() {
        this.query = this.type === "query";
        this.getDetail();
    },
    computed: {
        getExtraDetail() {
            return {
                initFormData: {
                    "search[EQ_billImportParentId]": this.id,
                },
                startUp: true,
                ajaxRequest: HttpImportItem,
            };
        },
        getBase() {
            return [
                {
                    label: "Tracking NO",
                    key: "trackingNo",
                },
                {
                    label: this.$t("erp.b2border.invoice", {
                        defaultValue: "发票号",
                    }),
                    key: "invoiceNo",
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    label: this.$t("fbb.bill.logistics_products", {
                        defaultValue: "物流产品",
                    }),
                    key: "carrierCode",
                },
                {
                    label: this.$t("fbb.alloment.carrier_server", {
                        defaultValue: "承运商服务",
                    }),
                    // label: "承运商服务",
                    key: "carrierServiceCode",
                },
                {
                    label: this.$t("fbb.alloment.taskNo", {
                        defaultValue: "任务编号",
                    }),
                    key: "taskNo",
                },
                {
                    label: this.$t("fbb.fedex.account", {
                        defaultValue: "结算账户",
                    }),
                    key: "account",
                },
                {
                    label: "Net Charge Amount",
                    // key: "discountCost",
                    valueText: this.formData.discountCost + " USD",
                },
            ];
        },
        getPackage() {
            return [
                {
                    label: "Dim Length",
                    // key: "packageLength",
                    valueText: this.formData.packageLength + " inch",
                },
                {
                    label: "Dim Width",
                    // key: "packageWidth",
                    valueText: this.formData.packageWidth + " inch",
                },
                {
                    label: "Dim Height",
                    // key: "packageHeight",
                    valueText: this.formData.packageHeight + " inch",
                },
                {
                    label: "Actual Weight Amount",
                    // key: "packageWeight",
                    valueText: this.formData.packageWeight + " lbs",
                },
                {
                    label: "Rated Weight Amount",
                    // key: "ratedWeight",
                    valueText: this.formData.ratedWeight + " lbs",
                },
            ];
        },
        getBaseCost() {
            return [
                {
                    label: "Transportation Charge Amount",
                    // key: "totalCost",
                    valueText: this.formData.totalCost + " USD",
                },
                {
                    label: "Grace Discount",
                    // key: "graceDiscount",
                    valueText: this.formData.graceDiscount + " USD",
                },
                {
                    label: "Performance Pricing",
                    // key: "performancePricing",
                    valueText: this.formData.performancePricing + " USD",
                },
                {
                    label: "Earned Discount",
                    // key: "earnedDiscount",
                    valueText: this.formData.earnedDiscount + " USD",
                },
            ];
        },
        columnsList() {
            return [
                {
                    title: this.$t("fbb.fedex.extracost_name", {
                        defaultValue: "附加费名称",
                    }),
                    key: "costName",
                },
                {
                    title: this.$t("fbb.adjustment.list_cost", {
                        defaultValue: "收费金额",
                    }),
                    key: "cost",
                },
                {
                    title: this.$t("erp.product_channel.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            if (this.type == "add") return;
            this.loading = true;
            HttpBillImportOne({
                id: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
            if (this.query) {
                // 请求日志的接口
                HttpGetLog({
                    id: this.id,
                    module: 30,
                }).then(
                    (res) => {
                        this.opLogList = res.data;
                    },
                    (err) => {}
                );
            }
        },
        handleResponse(data = {}) {
            this.formData = data;
            let jsondata = JSON.parse(data.metaData);
            console.log(jsondata);
            for (let key in jsondata) {
                let dataone = {
                    costName: key,
                    cost: jsondata[key],
                    currency: data.currency,
                };
                this.extraList.push(dataone);
            }
        },
        cancel() {
            this.$router.push({ name: "fedexBillimport" });
        },
    },
};
</script>
